import { DeliveryAreaCreateProvider } from "../../hooks/useDeliveryAreaCreateContext";
import { useParamAsNumber } from "../../hooks/useParamAsNumber";
import {
  DELIVERY_SCHEDULE,
  UPDATE_DELIVERY_AREA,
} from "../../constants/routes";
import { DeliveryAreaCreate } from "./DeliveryAreaCreate";
import { DeliveryAreaUpdate } from "./DeliveryAreaUpdate";

export const DeliveryArea = () => {
  const deliveryScheduleId = useParamAsNumber(
    DELIVERY_SCHEDULE,
    "deliveryAreaId",
    false,
  );
  const legacyDeliveryAreaId = useParamAsNumber(
    UPDATE_DELIVERY_AREA,
    "deliveryAreaId",
    false,
  );
  const deliveryAreaId = deliveryScheduleId ?? legacyDeliveryAreaId;

  return (
    <DeliveryAreaCreateProvider>
      {deliveryAreaId ? <DeliveryAreaUpdate /> : <DeliveryAreaCreate />}
    </DeliveryAreaCreateProvider>
  );
};
